export enum LocaleEnum {
  EN = 'en',
  FI = 'fi',
  SE = 'se',
  US = 'en-US',
}
